<div class="m-3">
  @if (items.length && !isLoader) {
    <mat-card>
      <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
        @for (item of items; track item) {
          <div cdkDrag class="example-box text-black" style="cursor: auto">
            <!--        <div class="d-flex justify-content-start align-items-center">-->
            <!--          <app-icon cdkDragHandle style="cursor: move">-->
            <!--            drag_indicator-->
            <!--          </app-icon>-->
            <!--          <div class="d-flex flex-column ">-->
            <!--            <span>{{item.title}}</span>-->
            <!--            <span>{{findByType(item.type)?.name}}</span>-->
            <!--          </div>-->
            <!--        </div>-->
            <div class="d-flex justify-content-start align-items-center w-50 overflow-hidden gap-2">
              <div class="d-flex center text-start">
                <app-icon cdkDragHandle class="drag-icon text-nowrap"> drag_indicator </app-icon>
              </div>
              <div class="d-flex flex-column text-truncate text-start">
                <span class="text-truncate">{{ item.title }}</span>
                <span class="text-truncate">{{ findByType(item.type)?.name }}</span>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <app-toggle [(ngModel)]="item.is_view" (ngModelChange)="updateCA(item)"></app-toggle>
              <app-button btnType="icon" (onChangeClick)="edit(item)">
                <app-icon>edit</app-icon>
              </app-button>
              <app-button btnType="icon" (onChangeClick)="deleteCA(item)">
                <app-icon>delete</app-icon>
              </app-button>
            </div>
          </div>
        }
      </div>
    </mat-card>
  }
  @if (isLoader) {
    <div class="d-flex align-items-center justify-content-center">
      <app-loader size="small"></app-loader>
    </div>
  }
  @if (!isLoader) {
    <div class="mt-2 d-flex flex-column align-items-center justify-content-center gap-4">
      @if (!items.length) {
        <span class="text-center text-dark">{{ 'no_one_field' | translate }}</span>
      }
      <app-button (onChangeClick)="openModal()">{{ 'аdd_field' | translate }}</app-button>
    </div>
  }
</div>
